import { Subject } from 'rxjs';

export interface IPropertyChangedEvent {
  propertyName: string;
  oldValue: any;
  newValue: any;
  origEvent: IPropertyChangedEvent;
}

export interface IBaseModel {
  changed: Subject<IPropertyChangedEvent>;

  toJSON(): any;

  propertiesToJSON(objectToExtend: any): any;
}

export class BaseModel implements IBaseModel {

  public changed: Subject<IPropertyChangedEvent> = new Subject();
  public modelType: string;

  get modelTypeProperty(): string {
    return this.modelType;
  }

  static fromJSON(json: any): BaseModel {
    throw new Error('this should not happen, fromJSON should be implemented on the concrete class');
  }

  public toJSON(): any {
    const ret = this.propertiesToJSON({});
    ret.modelType = this.modelType;

    return ret;
  }

  constructor(modelType: string) {
    this.modelType = modelType;
  }

  protected emitChanged(event: IPropertyChangedEvent = null) {
    this.changed.next(event);
  }

  protected setProperty(propertyName: string, newValue: any) {
    const oldValue = (<any>this)['_' + propertyName];
    if (oldValue !== newValue) {
      (<any>this)['_' + propertyName] = newValue;
      const event: IPropertyChangedEvent = {
        propertyName: propertyName,
        oldValue: oldValue,
        newValue: newValue,
        origEvent: null
      };
      this.emitChanged(event);
    }
  }

  public propertiesToJSON(objectToExtend: any) {
    Object.keys(this).forEach((propertyName: string) => {
      const propertyNameAsString: String = String(propertyName);
      if (propertyNameAsString.startsWith('_')) {
        // we want to get only the properties starting with the underscore.
        const setGetPropertyName = propertyNameAsString.substring(1);
        objectToExtend[setGetPropertyName] = (<any>this)[propertyName];
      }
    });

    // we don't have to return it since the work is being done on the given reference. but
    // it makes the api simpler
    return objectToExtend;
  }

}
